import React from 'react';
var Close = function (_a) {
    var width = _a.width, height = _a.height, opacity = _a.opacity, fill = _a.fill;
    return (React.createElement("svg", { width: width, height: height, opacity: opacity, viewBox: "0 0 98 96" },
        React.createElement("path", { fill: "none", stroke: fill, strokeLinecap: "square", strokeWidth: 5, d: "M1.083.083l95.834 95.834m0-95.834L1.083 95.917" })));
};
export default Close;
